<template>
    <rkm-overlay>
        <rkm-layout-body
            title="Ficha de vacinação"
        >
            <template
                v-slot:actions
            >
                <rkm-button
                    color="danger"
                    @click="handleExit"
                >
                    Sair
                </rkm-button>
            </template>
        </rkm-layout-body>

        <rkm-layout-content>
            <Form />
        </rkm-layout-content>
    </rkm-overlay>
</template>

<script>
import Form from  '@/components/atencao-basica/ficha-vacinacao/Form'

export default {
    components: {
        Form
    },
    methods: {
        handleExit() {
            this.$router.push({ name: 'atencao-basica-ficha-vacinacao' })
        },
    }
}
</script>